exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  margin: 0 0 10px;\n}\n\npre {\n  background-color: #f5f5f5;\n  padding: 15px;\n}\n\n.btn-outline-secondary {\n  border: 1 solid grey;\n}\n\n.btn-group, .btn-group-vertical {\n  z-index: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-event/calendar.component.css
// module id = ../../../../../src/app/pages/view-event/calendar.component.css
// module chunks = main